import debounce from 'lodash.debounce'
import React, { useContext } from 'react'

import FormText from '@f/elements/FormText/FormText'
import {
  InputValidation,
  isFailedSingleFieldValidation
} from '@f/elements/FormText/ValidationUtils'

import { QuizContext } from '../context/QuizContext'
import QuestionHeading from '../partials/QuestionHeading'
import { QuizStep } from '../partials/types'

const validations: InputValidation[] = [
  {
    rule: 'not-empty',
    message: 'Bitte Haushaltsnettoeinkommen angeben.'
  },
  {
    rule: 'is-number',
    message: 'Bitte geben Sie eine gültige Zahl ein.'
  },
  {
    rule: 'is-greater-than-zero',
    message: 'Bitte geben Sie eine Zahl größer als 0 ein.'
  }
]

export const QuestionHouseholdIncome = ({ step }: { step: QuizStep }) => {
  const context = useContext(QuizContext)
  const [error, setError] = React.useState('')
  const [inputValue, setInputValue] = React.useState(step.values[0].value)

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value

    const errorMessage = validations.find(validation => {
      return isFailedSingleFieldValidation(value, validation)
    })

    if (errorMessage) {
      setError(errorMessage.message)
      return
    }
    setError('')
    setInputValue(value)
    context.actions.updateValues({
      stepID: step.id,
      valuesToSave: [
        {
          name: step.values[0].name,
          value: value
        }
      ]
    })
  }

  return (
    <>
      <QuestionHeading heading={step.heading} subheading={step.subheading} />
      <div className='f-p-h-020 f-m-v-l-auto f-m-v-r-auto f-m-t-020 HouseholdIncome-InputWrapper'>
        <FormText
          formElement
          inputField
          validation={validations}
          error={error}
          className='f-c-bo-neu025 has-border is-full-width HouseholdIncome-Input'
          name='household-income'
          placeholder='Haushaltsnettoeinkommen pro Monat (€)'
          defaultValue={inputValue}
          autoComplete='off'
          onChange={debounce(handleOnChange, 300)}
        />
      </div>
    </>
  )
}
